// LoginBrandPanel.js - Panel de marca del split-screen de acceso
// Compartido por login, recuperación y reseteo de contraseña
import React from 'react';

// Módulos de la suite que rota el ticker del panel de marca
const MODULES = [
  'Gestión de tareas',
  'Sprints',
  'Panel SEO',
  'Google Ads',
  'Meta Ads',
  'Creatividades',
  'Crawls',
  'Documentación'
];

// Memoizado: no recibe props y es lo más caro de la pantalla (aurora + ticker +
// marca de agua). Sin memo se re-renderizaba en cada tecla del formulario.
const LoginBrandPanel = React.memo(() => (
  /* Panel de marca: aurora en movimiento + logo fijo en marca de agua */
  <div className="login-brand">
    <div className="login-aurora" aria-hidden="true">
      <span></span><span></span><span></span>
    </div>
    <div className="login-frame" aria-hidden="true"></div>
    <div
      className="login-watermark"
      aria-hidden="true"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/wm-mark.png)` }}
    ></div>

    <h1>
      Marketing
      <span className="hollow">Suite</span>
    </h1>

    <div className="login-ticker" aria-hidden="true">
      <span className="ticker-label">Dentro:</span>
      <div className="ticker-window">
        <ul>
          {[...MODULES, MODULES[0]].map((mod, idx) => (
            <li key={idx}>
              <i>{String((idx % MODULES.length) + 1).padStart(2, '0')}</i> {mod}
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="login-web">
      <a href="https://jonathanva.com" target="_blank" rel="noopener noreferrer">
        jonathanva.com
      </a>
    </div>
  </div>
));

LoginBrandPanel.displayName = 'LoginBrandPanel';

export default LoginBrandPanel;
